import {
  FreeTextQuestionFormItemResponses,
  UserDisplay,
} from "@coaching-culture/types";
import {
  Box,
  Flex,
  Label,
  PanelHeader,
  PanelInset,
  StatTile,
  Text,
  usePagination,
} from "@coaching-culture/ui";
import { useUser } from "auth";
import { FaQuestionCircle } from "react-icons/fa";
import styled from "styled-components";

const ResponseContainer = styled(Flex)`
  position: relative;
  page-break-inside: avoid;
`;

export type FreeTextInsightsProps = {
  item: FreeTextQuestionFormItemResponses;
  user: UserDisplay;
  showResponses: boolean;
  paginated: boolean;
};

export function FreeTextInsights({
  item,
  user,
  showResponses,
  paginated,
}: FreeTextInsightsProps) {
  const [currentUser] = useUser();

  const userText = currentUser?.id === user?.id ? "Your" : "User's";
  const yourAnswer = item.responses.find((x) => x.email === user?.email);

  const responses = item.responses;

  const {
    data: pagedResponses,
    pageCount,
    component: Pagination,
  } = usePagination(responses, paginated ? 8 : 99999999, 1);

  const responseCount = responses.filter((x) => x.email !== user?.email).length;

  return (
    <PanelInset mb={3}>
      <PanelHeader>
        <FaQuestionCircle aria-hidden />
        <Text fontWeight={600} ml={2} color="black">
          {item.content}
        </Text>
      </PanelHeader>
      <Box p={3} pb={0} maxWidth="272px">
        <StatTile label="Responses" value={responseCount} />
      </Box>
      {user != null && (
        <Flex flexDirection="column" p={3}>
          <Box mb={2}>
            <Text fontWeight={500} fontSize="small" color="textMuted" mb={1}>
              {userText} answer
            </Text>
            <Text>{yourAnswer?.content ?? "<None given>"}</Text>
          </Box>
        </Flex>
      )}
      {showResponses && responses.length > 0 && (
        <Flex flexDirection="column" p={3} style={{ position: "relative" }}>
          <Text as="h4" mt={0} fontSize="title" fontWeight={600} mb={3}>
            Responses
          </Text>
          {pagedResponses.map((x, i) => (
            <ResponseContainer
              key={i}
              flexDirection="column"
              mb={i === item.responses.length - 1 ? 0 : 3}
            >
              <Flex alignItems="center" mb={1}>
                <Text fontWeight={600}>Respondent: {x.name} </Text>
                {x.email === user?.email ? (
                  <Label size="small" ml={2}>
                    {userText} response
                  </Label>
                ) : null}
              </Flex>
              <Text>{x.content ?? "<None given>"}</Text>
            </ResponseContainer>
          ))}
          {pageCount > 1 && (
            <Box p={2}>
              <Pagination />
            </Box>
          )}
        </Flex>
      )}
    </PanelInset>
  );
}
